import React from "react";
import SuiTypography from "components/SuiTypography";

function FieldLabel({ children }) {
  return (
    <SuiTypography variant="caption" color="text" fontWeight="medium" display="block" mb={0.5}>
      {children}
    </SuiTypography>
  );
}

export default FieldLabel;
